export default "__VITE_ASSET__BziENTx2__"